import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import ContextPropertyTab from "./ContextPropertyTab";
import HeaderConfiguration from "../components/HeaderConfiguration";
import InputPortList from '../components/InputPortList';
import LimitSameValues from '../components/LimitSameValues';
import ContextUpdaterTab from "./ContextUpdaterTab";
import PanelLayout from "../components/PanelLayout";

class OutputPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: "Blender",
        };
        this.changeTab = this.changeTab.bind(this);
    }

    changeTab(event) {
        this.setState({selectedTab: event.currentTarget.dataset.id});
    }

    render() {
        return (
            <>
                <PanelLayout headerTabs={<>
                    <span data-id="Blender" onClick={this.changeTab}
                          className={this.state.selectedTab === "Blender" ? "navigation-tab current" : "navigation-tab"}>Blender</span>
                    <span data-id="Settings" onClick={this.changeTab}
                          className={this.state.selectedTab === "Settings" ? "navigation-tab current" : "navigation-tab"}>Settings</span>
                    <span data-id="Context Properties" onClick={this.changeTab}
                          className={this.state.selectedTab === "Context Properties" ? "navigation-tab current" : "navigation-tab"}>Context Properties</span>
                    <span data-id="Context Updaters" onClick={this.changeTab}
                          className={this.state.selectedTab === "Context Updaters" ? "navigation-tab current" : "navigation-tab"}>Context Updaters</span>
                </>}
                             customTabs
                >
                    <div
                        className={this.state.selectedTab === "Blender" ? "gui-editor-content active" : "gui-editor-content"}>
                        <HeaderConfiguration/>
                        <InputPortList/>
                    </div>
                    <div
                        className={this.state.selectedTab === "Settings" ? "gui-editor-content active" : "gui-editor-content"}>
                        <LimitSameValues/>
                    </div>
                    <div
                        className={this.state.selectedTab === "Context Properties" ? "gui-editor-content active" : "gui-editor-content"}>
                        <ContextPropertyTab/>
                    </div>
                    <div
                        className={this.state.selectedTab === "Context Updaters" ? "gui-editor-content active" : "gui-editor-content"}>
                        <ContextUpdaterTab/>
                    </div>
                </PanelLayout>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        content: state.modalInfo.content,
        node: state.modalInfo.node
    }
}

export default connect(mapStateToProps, {hideModal})(OutputPanel);